<template>
  <div class="ws-info-file">
    <div class="ws-info-file__upload-btns">
      <WsStateFileItem
        :url="value"
        :updatable="false"
        class="mb-2"
      ></WsStateFileItem>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      defalut: "",
    },
  },
};
</script>

<style>
</style>